import React from 'react';
import { Wallet, Banknote, HandCoins, MessageCircle, CreditCard, Coins } from 'lucide-react';

// Import images
import solideLogo from '../assets/images/services/solide.webp';
import kolaboConnectLogo from '../assets/images/services/kolanoconnect.webp'; // Note: typo in original filename preserved
import biofritLogo from '../assets/images/services/biofrit.webp';
import famamobileLogo from '../assets/images/services/famamobile.webp';
import htlaLogo from '../assets/images/services/htla.webp';
import imolinkLogo from '../assets/images/services/imolink.webp';
import kolaboLogo from '../assets/images/services/kolabo.webp';
import kolaboExpressLogo from '../assets/images/services/kolaboexpress.webp';

export interface ServiceItem {
    id: number;
    name: string;
    logo?: string;
    icon?: React.ReactNode;
    nameKey: string;
    descKey: string;
    route: string;
    underConstruction?: boolean;
}

export const servicesList: ServiceItem[] = [
    // Services prioritaires
    {
        id: 1,
        name: 'Bousanm Solidè',
        logo: solideLogo,
        nameKey: 'dashboard:servicesGrid.solide',
        descKey: 'services:serviceDetails.service1.desc',
        route: '/services/solide'
    },
    {
        id: 2,
        name: 'Kolabo Connect',
        logo: kolaboConnectLogo,
        nameKey: 'dashboard:servicesGrid.kolanoConnect',
        descKey: 'services:serviceDetails.service2.desc',
        route: '/services/kolabo-connect'
    },
    // Services originaux avec icônes
    {
        id: 3,
        name: 'Ti kanè Bousanm',
        icon: <Wallet size={28} className="text-green-600" />,
        nameKey: 'dashboard:servicesGrid.tiKane',
        descKey: 'services:serviceDetails.service1.desc',
        route: '/services/ti-kane'
    },
    {
        id: 4,
        name: 'Sòl (Mutuelle)',
        icon: <Banknote size={28} className="text-green-600" />,
        nameKey: 'dashboard:servicesGrid.sol',
        descKey: 'services:serviceDetails.service2.desc',
        route: '/services/sol'
    },
    {
        id: 5,
        name: 'Placement Bousanm',
        icon: <HandCoins size={28} className="text-green-600" />,
        nameKey: 'dashboard:servicesGrid.placement',
        descKey: 'services:serviceDetails.service3.desc',
        underConstruction: true,
        route: '/services/placement'
    },
    {
        id: 6,
        name: 'Prêt',
        icon: <MessageCircle size={28} className="text-green-600" />,
        nameKey: 'dashboard:servicesGrid.pret',
        descKey: 'services:serviceDetails.service4.desc',
        route: '/services/pret'
    },
    {
        id: 7,
        name: 'Acheter crédit',
        icon: <Coins size={28} className="text-green-600" />,
        nameKey: 'dashboard:servicesGrid.acheterCredit',
        descKey: 'services:serviceDetails.service5.desc',
        route: '/services/credit'
    },
    {
        id: 8,
        name: 'Payer SOL',
        icon: <CreditCard size={28} className="text-green-600" />,
        nameKey: 'dashboard:servicesGrid.payerSOL',
        descKey: 'services:serviceDetails.service6.desc',
        route: '/services/payer-sol'
    },
    // Autres nouveaux services avec logos
    {
        id: 9,
        name: 'Biofrit',
        logo: biofritLogo,
        nameKey: 'dashboard:servicesGrid.biofrit',
        descKey: 'services:serviceDetails.service9.desc',
        route: '/services/biofrit'
    },
    {
        id: 10,
        name: 'Famamobile',
        logo: famamobileLogo,
        nameKey: 'dashboard:servicesGrid.famamobile',
        descKey: 'services:serviceDetails.service10.desc',
        route: '/services/famamobile'
    },
    {
        id: 11,
        name: 'HTLA',
        logo: htlaLogo,
        nameKey: 'dashboard:servicesGrid.htla',
        descKey: 'services:serviceDetails.service11.desc',
        route: '/services/htla'
    },
    {
        id: 12,
        name: 'Imolink',
        logo: imolinkLogo,
        nameKey: 'dashboard:servicesGrid.imolink',
        descKey: 'services:serviceDetails.service12.desc',
        route: '/services/imolink'
    },
    {
        id: 13,
        name: 'Kolabo Tech',
        logo: kolaboLogo,
        nameKey: 'dashboard:servicesGrid.kolabo',
        descKey: 'services:serviceDetails.service13.desc',
        route: '/services/kolabo-tech'
    },
    {
        id: 14,
        name: 'Kolabo Express',
        logo: kolaboExpressLogo,
        nameKey: 'dashboard:servicesGrid.kolaboExpress',
        descKey: 'services:serviceDetails.service14.desc',
        route: '/services/kolabo-express'
    },
];

export default servicesList;
